import { Logo, Text } from '@myinterview/component-library';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  logo: string;
  companyName: string;
  jobTitle: string;
  hidden?: boolean;
  forDesktopLayout?: boolean;
}

export const Header:React.FC<IProps> = ({
  logo = '', companyName = '', jobTitle = '', hidden = false, forDesktopLayout = false,
}) => {
  const { t } = useTranslation();
  const headerClassNames = classNames({
    'myinterview-widget-header': true,
    'myinterview-widget-header--hidden': hidden,
    'myinterview-widget-header--desktop-layout': forDesktopLayout,
  });
  return (
    <header className={headerClassNames}>
      {logo && <Logo className="myinterview-widget-header__logo" url={logo} isLoading={false} />}

      <div className="myinterview-widget-header__details-wrapper">
        <Text
          className="myinterview-widget-header__job-title"
          color="white"
          size="M-Semibold"
          isTruncated
        >
          {jobTitle}
        </Text>

        <Text
          className="myinterview-widget-header__company-name"
          color="white"
          size="S-Regular"
          isTruncated
        >
          {`${t('layout.at')} ${companyName}`}
        </Text>

      </div>
    </header>
  );
};
